import React, { useState } from 'react';
import { FormControl, Select, MenuItem } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(2),
  },
  listItemText: {
    marginTop: theme.spacing(1),
    fontSize: '1.0em',
  }
}));

const StatusList = ({ uid, status_in, disabled, setNewStatus }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [status, setStatus] = useState(status_in);
  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setStatus(e.target.value);
    setNewStatus(uid, newStatus);
  };

  return (
    <form noValidate>
      <FormControl>
        <Select
          className={classes.listItemText}
          disabled={disabled}
          value={status_in}
          onChange={handleStatusChange}
        >
          <MenuItem value="Active">{t("active")}</MenuItem>
          <MenuItem value="Disabled">{t("disabled")}</MenuItem>
        </Select>
      </FormControl>
    </form>
  );
};

export default StatusList;